import React, { useState } from "react";
import { useMutation } from "@apollo/client";
import "./SignInForm.css";
import Button from "../../../Button";
import PropType from "prop-types";
import { UPDATE_USER_ACCOUNT_INFO } from "./queries";
import LoadingOverlay from "react-loading-overlay";

export default function AccountInfoForm(props) {
  const [firstName, setFirstName] = useState(props.firstName);
  const [lastName, setLastName] = useState(props.lastName);
  const [displayName, setDisplayName] = useState(props.displayName);
  const [slackEmail, setSlackEmail] = useState(props.slackEmail);
  const [showLoading, setShowLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(undefined);

  const [updateUserAccountInfo] = useMutation(UPDATE_USER_ACCOUNT_INFO);

  function setValue(valueFunc, value) {
    valueFunc(value);
  }

  function handleSubmit(e) {
    e.preventDefault();

    setShowLoading(true);
    setErrorMessage(undefined);

    updateUserAccountInfo({
      variables: {
        firstName: firstName,
        lastName: lastName,
        displayName: displayName,
        slackEmail: slackEmail,
      },
    })
      .then(() => setShowLoading(false))
      .catch(() => {
        setErrorMessage("Something went wrong. Please try again later.");
        setShowLoading(false);
      });
  }

  return (
    <LoadingOverlay
      active={showLoading}
      spinner
      text="Updating account info..."
    >
      <form id="signin-form" className="signin-form" onSubmit={handleSubmit}>
        <div className="signin-form-row">
          <label htmlFor="account-first-name" className="signin-label">
            First Name
          </label>
          <input
            id="account-first-name"
            name="account-first-name"
            className="signin-input"
            value={firstName}
            type="text"
            onChange={(event) => {
              setValue(setFirstName, event.target.value);
            }}
          />

          <label htmlFor="account-last-name" className="signin-label">
            Last Name
          </label>
          <input
            id="account-last-name"
            name="account-last-name"
            className="signin-input"
            value={lastName}
            type="text"
            onChange={(event) => {
              setValue(setLastName, event.target.value);
            }}
          />

          <label htmlFor="account-display-name" className="signin-label">
            Display Name
          </label>
          <input
            id="account-display-name"
            name="account-display-name"
            className="signin-input"
            value={displayName}
            type="text"
            onChange={(event) => {
              setValue(setDisplayName, event.target.value);
            }}
          />

          <label htmlFor="account-slack-email" className="signin-label">
            Slack Email
          </label>
          <input
            id="account-slack-email"
            name="account-slack-email"
            className="signin-input"
            value={slackEmail}
            type="text"
            onChange={(event) => {
              setValue(setSlackEmail, event.target.value);
            }}
          />

          {errorMessage !== undefined ? (
            <p className="signin-error">{errorMessage}</p>
          ) : null}
        </div>
        <br />
        <Button form={true}>Update Info</Button>
      </form>
    </LoadingOverlay>
  );
}

AccountInfoForm.propTypes = {
  firstName: PropType.string.isRequired,
  lastName: PropType.string.isRequired,
  displayName: PropType.string.isRequired,
};
